import { ReactNode } from 'react';
import { Box, Text, Stack } from '@mantine/core';

interface FormFieldProps {
  label: string;
  required?: boolean;
  children: ReactNode;
  error?: string;
}

/**
 * Form field layout - always stacked (label on top, input below)
 * Cleaner and more consistent across all screen sizes
 */
export function FormField({ label, required, children, error }: FormFieldProps) {
  return (
    <Stack gap={4}>
      <Text size="sm" fw={500} c={error ? 'red' : undefined}>
        {label}
        {required && (
          <Text component="span" c="red" ml={2}>
            *
          </Text>
        )}
      </Text>
      <Box>{children}</Box>
      {error && (
        <Text size="xs" c="red">
          {error}
        </Text>
      )}
    </Stack>
  );
}
